import React from 'react';
import {ButtonProps, Button as MuiButton} from '@mui/material';
import * as Sentry from '@sentry/react';
import {Link} from 'react-router-dom';

type LinkButtonProps = Omit<ButtonProps, 'href' | 'component'> & {
  eventName: string | null;
  component: typeof Link;
  to: string;
  href?: never;
};

type RegularButtonProps = Omit<ButtonProps, 'href'> & {
  eventName: string | null;
  component?: never;
  to?: never;
  href?: string;
};

type CustomButtonProps = LinkButtonProps | RegularButtonProps;

export const Button: React.FC<CustomButtonProps> = ({
  onClick,
  children,
  eventName,
  ...props
}) => {
  return (
    <MuiButton
      onClick={(e) => {
        try {
          // LogRocket.track(`Clicked ${eventName}`);
          Sentry.addBreadcrumb({
            category: 'UI Click',
            message: `Clicked ${eventName}`,
            level: 'info',
          });
        } catch (err) {
          // do nothing
        }
        if (onClick) {
          onClick(e);
        }
      }}
      {...props}
    >
      {children}
    </MuiButton>
  );
};
